
import {Options, Vue} from "vue-class-component";
import {FuneralPlanTab} from "@/shared/domain/enum/funeral-plan-tab.model";
@Options({
    data: function() {
        return {
            FuneralPlanTab,
        }
    },
    props: {
        funeralPlanTab: {
            type: String,
            value: null
        }
    },
    computed: {
        isPrevent() {
            return this.funeralPlanTab === FuneralPlanTab.PREVENT;
        }
    }
})
export default class TabIcon extends Vue {}
